import React, { useState } from 'react';
import './Upload.css';

export default function RecordingFormatDialog({ dataset, initialFormat, onLoad, onClose, error }) {
  const [format, setFormat] = useState(initialFormat || {
    channels: '', dtype: 'int16', sampleRateHz: 30000, offsetBytes: 0, layout: 'interleaved', byteOrder: 'little',
  });
  const [loading, setLoading] = useState(false);
  const update = (name) => (event) => setFormat(previous => ({ ...previous, [name]: event.target.value }));
  return <div className="upload-overlay">
    <form className="upload-modal" role="dialog" aria-label="Recording format" onSubmit={async event => {
      event.preventDefault(); setLoading(true);
      try { await onLoad(format); } finally { setLoading(false); }
    }}>
      <div className="upload-header"><h2>Recording format</h2>
        <button type="button" onClick={onClose} disabled={loading} aria-label="Close recording format">×</button></div>
      <div className="upload-body" style={{ display: 'grid', gap: 14 }}>
        <strong>{dataset}</strong>
        <p>Raw files do not contain their shape. Use the acquisition settings, including any saved sync channel. These settings are saved for this recording.</p>
        <label>Number of channels <input aria-label="Number of channels" type="number" min="1" max="65536" required value={format.channels} onChange={update('channels')} /></label>
        <label>Sample type <select aria-label="Sample type" value={format.dtype} onChange={update('dtype')}>
          {['int8', 'uint8', 'int16', 'uint16', 'int32', 'float32', 'float64'].map(type => <option key={type}>{type}</option>)}
        </select></label>
        <label>Byte order <select aria-label="Byte order" value={format.byteOrder || 'little'} onChange={update('byteOrder')}>
          <option value="little">Little-endian</option>
          <option value="big">Big-endian</option>
        </select></label>
        <label>Sample rate (Hz) <input aria-label="Sample rate (Hz)" type="number" min="1" required value={format.sampleRateHz} onChange={update('sampleRateHz')} /></label>
        <label>Sample order <select aria-label="Sample order" value={format.layout} onChange={update('layout')}>
          <option value="interleaved">Interleaved: all channels per sample</option>
          <option value="channel-major">Channel-major: all samples per channel</option>
        </select></label>
        <label>Header bytes to skip <input aria-label="Header bytes to skip" type="number" min="0" required value={format.offsetBytes} onChange={update('offsetBytes')} /></label>
        {error && <p role="alert">{error}</p>}
        <button className="upload-submit-button" type="submit" disabled={loading}>{loading ? 'Loading…' : 'Load recording'}</button>
      </div>
    </form>
  </div>;
}
